<template>
  <div class="homeBox" v-show="showStatus" style="display: none;">
    <Header :colorType='colorType' :pageType='pageType' class="header" id="headers"></Header>
    <div class="content">
      <Carousel @transferColorType = "getColorType"></Carousel>
      <Service></Service>
      <Function></Function>
      <Pay></Pay>
      <Business></Business>
      <Partner></Partner>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/header/Header'
import Carousel from '@/components/home/carousel'
import Service from '@/components/home/service'
import Function from '@/components/home/Function'
import Pay from '@/components/home/pay'
import Business from '@/components/home/business'
import Partner from '@/components/home/partner'
import Footer from '@/components/footer/Footer'
export default {
  name: 'Home',
  data: function () {
    return {
      showStatus: false,
      top: 0,
      colorType: '1',
      oldType: '',
      pageType: 'home',
      oldTop: 0,
      oldLeft: 0,
      scrollLeft: false
    }
  },
  components: {
    Header,
    Carousel,
    Service,
    Function,
    Pay,
    Business,
    Partner,
    Footer
  },
  mounted: function () {
    this.showStatus = true
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll: function () {
      this.top = document.documentElement.scrollTop || document.body.scrollTop
      if (this.top > 605) {
        this.colorType = 3
      } else {
        this.colorType = this.oldType
      }
    },
    getColorType: function (type) {
      this.oldType = type
      if (this.top <= 605) {
        this.colorType = type
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}
.header{
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  min-width: 1300px;
}
.content{
  z-index: 999;
  min-width: 1300px;
}
.bannerBox{
  padding-top: 120px;
  background-color: RGBA(255, 182, 30, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue